// App.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import CasesList from "./pages/CasesList";
import CaseDetail from "./pages/CaseDetail";
import AddCase from "./pages/AddCase";
import KitsList from "./pages/KitsList";
import KitDetail from "./pages/KitDetail";
import AddKit from "./pages/AddKit";
import ProblemGear from "./pages/ProblemGear";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import UpdatePassword from "./pages/UpdatePassword";
import AddUser from "./pages/AddUser";
import UserList from "./pages/UserList";
import { Toaster } from "react-hot-toast";

import "./App.css";
import "primeicons/primeicons.css";

function App() {
	const { loading } = useAuth();
	const location = useLocation();

	if (loading) {
		return (
			<div className="loading">
				<div>
					<i className="pi pi-spin pi-spinner"></i>
				</div>
			</div>
		);
	}

	return (
		<>
			<Toaster position="top-right" />
			<Navbar />
			<div style={{ display: "flex", position: "relative" }}>
				<Routes>
					{/* Public routes */}
					<Route path="/login" element={<Login />} />
					<Route path="/" element={<CasesList />} />
					<Route path="/cases/:id" element={<CaseDetail />} />
					<Route path="/kits" element={<KitsList />} />
					<Route path="/kits/:id" element={<KitDetail />} />

					{/* Protected routes */}
					<Route
						path="/add-case"
						element={
							<ProtectedRoute>
								<AddCase />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/add-kit"
						element={
							<ProtectedRoute>
								<AddKit />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/problem-gear"
						element={
							<ProtectedRoute>
								<ProblemGear />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/update-password"
						element={
							<ProtectedRoute>
								<UpdatePassword />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/add-user"
						element={
							<ProtectedRoute>
								<AddUser />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/view-users"
						element={
							<ProtectedRoute>
								<UserList />
							</ProtectedRoute>
						}
					/>
				</Routes>
			</div>
		</>
	);
}

export default App;
